import Moment from 'moment';
import {
  ADD_TOAST,
  ADD_MUTED_TOAST,
  DELETE_TOAST
} from './../actions/toasts';

const initialState = { recentToasts: [] };

const addToastToState = (state, action) => {
  // protect against action that is still called on an ignored toast
  if (!action.payload.type) {
    return state;
  }

  const newToast = {
    toastType: action.payload.type,
    message: action.payload.title,
    time: Moment().format('MMMM D, YYYY h:mm:ss A')
  };
  return {
    ...state,
    recentToasts : [
      newToast,
      ...(state.recentToasts.length < 10 ?
        state.recentToasts :
        state.recentToasts.slice(0, -1)
      )
    ]
  };
};

const toasts = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TOAST:
      // this listens in on the same action type that react-redux-toastr uses within
      // its toastrReducer in order to snoop the contents into our persistent list.
      // Currently it does not filter out any type of toast from our list.
      return addToastToState(state, action);
    case ADD_MUTED_TOAST: {
      // this listens for a rewritten middleware toast action
      return addToastToState(state, action);
    }
    case DELETE_TOAST:
      return {
        ...state,
        recentToasts: state.recentToasts.filter(toast => toast !== action.toast)
      };

    default:
      return state;
  }
};

export default toasts;

export const getRecentToasts = state => state.toasts.recentToasts;


// WEBPACK FOOTER //
// src/reducers/toasts.js